import React, { useState, useCallback, useMemo } from 'react';
import usePagination from '../../../hooks/usePagination';
import PaginationBlock from '../components/ui/PaginationBlock/PaginationBlock';

let initPageSize = 10;

const useTablePagination = (data, init) => {
  const { currentPage, setCurrentPage } = init || {};

  const [pageSize, setPageSize] = useState(initPageSize);

  const [currentPageNumber, setCurrentPageNumber, maxPage, shownItems] =
    usePagination(data, pageSize, currentPage);

  const handlePageSizeChange = useCallback(
    (newPageSize) => {
      setPageSize(newPageSize);
      initPageSize = newPageSize;
      if (typeof setCurrentPage === 'function') {
        setCurrentPage(0);
      }
    },
    [setCurrentPage]
  );

  const handlePageChange = useCallback(
    (page) => {
      const pageNum = page - 1;

      setCurrentPageNumber(pageNum);

      if (typeof setCurrentPage === 'function') {
        setCurrentPage(pageNum);
      }
    },
    [setCurrentPageNumber, setCurrentPage]
  );

  const pagination = useMemo(
    () => (
      <PaginationBlock
        currentPageNumber={currentPageNumber}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        pageSize={pageSize}
        total={data?.length || 0}
        showQuickJumper={maxPage > 9}
      />
    ),
    [
      pageSize,
      handlePageSizeChange,
      currentPageNumber,
      handlePageChange,
      maxPage,
      data,
    ]
  );

  return {
    shownItems,
    pagination,
  };
};

export default useTablePagination;
